import axiosInstance from "./axios.service"

export interface ItemRankingDescription {
  _id?: string
  rankingItem: string
  name: string
  visibleByDefault: boolean
  rankingGroup: { _id: string; name: string }
  rankingGroups?: { _id: string; name: string }[]
  sortIndex?: number
}

export interface ItemRankingDescriptionIndex {
  _id: string
  sortIndex: number
}

export default { query, queryNoPaginate, save, arraySave, remove }

async function query(filter: any): Promise<ItemRankingDescription[]> {
  const params = { _select: '*', ...filter }
  const result = await axiosInstance.get('/api/itemRankingDescription', { params })
  return result.data
}

async function queryNoPaginate(filter: any): Promise<ItemRankingDescription[]> {
  const params = { _select: '*', ...filter, _paginate: false }
  const result = await axiosInstance.get('/api/itemRankingDescription', { params })
  return result.data
}

async function save(data: ItemRankingDescription): Promise<ItemRankingDescription> {
  const result = await axiosInstance.post('/api/itemRankingDescription', data)
  return result.data
}

async function arraySave(data: ItemRankingDescriptionIndex[]): Promise<ItemRankingDescription[]> {
  const result = await axiosInstance.post('/api/itemRankingDescription', data)
  return result.data
}

async function remove(_id: string): Promise<ItemRankingDescription> {
  if (!_id || _id.trim() === '') throw new Error('No se puede borrar sin id')
  const result = await axiosInstance.put('/api/itemRankingDescription', { _id })
  return result.data
}
